export default "__VITE_ASSET__cXooKnd___"